/** Mise en forme des montants, en un seul endroit. */

/**
 * Des centimes vers un montant lisible en euros.
 *
 * Les nouvelles tables comptent en centimes entiers : aucun arrondi ne se
 * produit ici, on ne fait que placer la virgule.
 */
export function euros(cents: number): string {
  return (cents / 100).toLocaleString('fr-BE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  });
}

/** Une date ISO vers le format belge, sans l'heure. */
export function dateCourte(iso: string | null | undefined): string {
  if (!iso) return '—';
  const [a, m, j] = iso.slice(0, 10).split('-');
  return `${j}/${m}/${a}`;
}
